import { useEffect, useState } from 'react';

const usePressHold = (callback = () => {}, ms = 1000) => {
    const [onHoldPress, setOnHoldPress] = useState(false);
    const [startTime, setStartTime] = useState(null);
    const [deltaTime, setDeltaTime] = useState(null);
    let endTime;

    const onPressHoldHandler = () => {
        document.body.classList.add('unselectable');
        setStartTime(new Date());
        setOnHoldPress(true);
    };

    const onUnpressHoldHandler = () => {
        endTime = new Date();
        setDeltaTime(endTime - startTime);
        setOnHoldPress(false);
        document.body.classList.remove('unselectable');
    };

    useEffect(() => {
        let timerId;
        if (onHoldPress) {
            timerId = setTimeout(callback, ms);
        } else {
            clearTimeout(timerId);
        }

        return () => {
            clearTimeout(timerId);
        };
    }, [onHoldPress, callback, ms]);

    return {
        ...(deltaTime > ms && {
            onClick: e => e.preventDefault(),
        }),
        onMouseDown: onPressHoldHandler,
        onMouseUp: onUnpressHoldHandler,
        onMouseLeave: onUnpressHoldHandler,
        onTouchStart: onPressHoldHandler,
        onTouchEnd: onUnpressHoldHandler,
    };
};

export default usePressHold;
